export default {
  winWidth (state) {
    return state.winWidth
  },
  winHeight (state) {
    return state.winHeight
  }
}
